import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

import { HomeMainMenuComponent } from '../../shared/home-main-menu/home-main-menu.component'; 

import { ScriptLoaderService, VENDOR_SCRIPTS } from '../../script-loader.service';
import { SubscribeComponent } from '../../shared/subscribe/subscribe.component';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule, HomeMainMenuComponent, RouterLink, SubscribeComponent],
  templateUrl: '../templates/home.component.html',
})
export class HomeComponent implements AfterViewInit, OnDestroy {
  constructor(private readonly scriptLoader: ScriptLoaderService) {}

  ngAfterViewInit(): void {
    document.body.classList.add('defult-home');
    this.scriptLoader
      .loadSequential(...VENDOR_SCRIPTS)
      .then(() => {
        // If vendor scripts were injected after the native load event,
        // re-dispatch it so jQuery load handlers in main.js still run.
        if (document.readyState === 'complete') {
          window.dispatchEvent(new Event('load'));
        }
        // On SPA navigation, main.js doesn't re-execute (scripts are cached),
        // so manually initialize any carousels/animations not yet set up.
        this.initOwlCarousels();
        this.initWow();
      })
      .catch((error) => {
        console.error('Failed to load third-party scripts', error);
      });
  }

  ngOnDestroy(): void {
    document.body.classList.remove('defult-home');
  }

  /** Re-initializes .rs-carousel elements that were not set up by main.js (SPA navigation). */
  private initOwlCarousels(): void {
    const $ = (window as any).jQuery;
    if (!$ || !$.fn || !$.fn.owlCarousel) { return; }

    $('.rs-carousel').each(function(this: Element) {
      const owlCarousel = $(this);
      if (owlCarousel.hasClass('owl-loaded')) { return; } // already initialized by main.js

      const loop         = owlCarousel.data('loop');
      const items        = owlCarousel.data('items');
      const margin       = owlCarousel.data('margin');
      const autoplay     = owlCarousel.data('autoplay');
      const autoplayTimeout = owlCarousel.data('autoplay-timeout');
      const smartSpeed   = owlCarousel.data('smart-speed');
      const dots         = owlCarousel.data('dots');
      const nav          = owlCarousel.data('nav');
      const navSpeed     = owlCarousel.data('nav-speed');
      const xsDevice     = owlCarousel.data('mobile-device');
      const xsDeviceNav  = owlCarousel.data('mobile-device-nav');
      const xsDeviceDots = owlCarousel.data('mobile-device-dots');
      const smDevice     = owlCarousel.data('ipad-device');
      const smDeviceNav  = owlCarousel.data('ipad-device-nav');
      const smDeviceDots = owlCarousel.data('ipad-device-dots');
      const smDevice2    = owlCarousel.data('ipad-device2');
      const smDeviceNav2 = owlCarousel.data('ipad-device-nav2');
      const smDeviceDots2 = owlCarousel.data('ipad-device-dots2');
      const mdDevice     = owlCarousel.data('md-device');
      const centerMode   = owlCarousel.data('center-mode');
      const hoverPause   = owlCarousel.data('hoverpause');
      const mdDeviceNav  = owlCarousel.data('md-device-nav');
      const mdDeviceDots = owlCarousel.data('md-device-dots');

      owlCarousel.owlCarousel({
        loop:                 !!loop,
        items:                items  || 4,
        lazyLoad:             true,
        center:               !!centerMode,
        autoplayHoverPause:   !!hoverPause,
        margin:               margin || 0,
        autoplay:             !!autoplay,
        autoplayTimeout:      autoplayTimeout || 1000,
        smartSpeed:           smartSpeed  || 250,
        dots:                 !!dots,
        nav:                  !!nav,
        navText:              ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
        navSpeed:             !!navSpeed,
        responsiveClass:      true,
        responsive: {
          0: {
            items: xsDevice  || 1,
            nav:   !!xsDeviceNav,
            dots:  !!xsDeviceDots,
            center: false,
          },
          576: {
            items: smDevice2  || 2,
            nav:   !!smDeviceNav2,
            dots:  !!smDeviceDots2,
            center: false,
          },
          768: {
            items: smDevice  || 3,
            nav:   !!smDeviceNav,
            dots:  !!smDeviceDots,
            center: false,
          },
          992: {
            items: mdDevice  || 4,
            nav:   !!mdDeviceNav,
            dots:  !!mdDeviceDots,
          },
        },
      });
    });
  }

  /** Re-initializes WOW.js animations when navigating back to this page. */
  private initWow(): void {
    const WOW = (window as any).WOW;
    if (WOW) {
      new WOW({ live: false }).init();
    }
  }
}


